import React, { useEffect, useState } from "react";
import MagnetCursor from "../components/MagnetCursor";
import ScrollToTop from "../components/ScrollToTop";
import Preloader from "../components/Preloader";
import HeaderArea from "../components/HomeFour/HeaderArea";
import HeroSection from "../components/HomeFour/HeroSection";
import AboutsSection from "../components/HomeFour/AboutsSection";
import PracticeArea from "../components/HomeFour/PracticeArea";
import TeamMembers from "../components/HomeFour/TeamMembers";
import WhyChooseUs from "../components/HomeFour/WhyChooseUs";
import Footer from "../components/HomeFour/Footer";
import BlogWrapper from "../components/HomeFour/BlogWrapper";
import TestimonialSection from "../components/HomeFour/TestimonialSection";
function HomeFour() {
  //preloader
  useEffect(() => {
    const preloader = document.getElementById("preloader");
    if (preloader) {
      preloader.style.display = "none";
    }
  }, []);

  return (
    <div className="theme-two">
      {/* Preloader */}
      <Preloader />

      {/* Search Form */}
      <div className="search-bg-overlay" id="searchOverlay"></div>
      <div className="search-form-popup">
        <h2 className="mb-4">How can I help you, Today?</h2>
        <button
          type="button"
          className="close-btn"
          id="searchClose"
          aria-label="Close"
        >
          &times;
        </button>
        <form className="search-form">
          <input
            type="search"
            className="form-control"
            placeholder="Search..."
            id="site-search"
            name="q"
          />
          <button type="submit" className="btn btn-primary">
            <span>
              <i className="ti ti-search"></i> Search Now
            </span>
            <span>
              <i className="ti ti-search"></i> Search Now
            </span>
          </button>
        </form>
      </div>

      {/* Header Area*/}
      <HeaderArea />

      {/* Hero Section */}
      <HeroSection />

      {/* Popup Video Container */}
      <div id="videoPopup" className="video-popup-iframe">
        <div className="video-content">
          <span className="close-btn" id="videoCloseButton">
            &times;
          </span>
          <div className="ratio ratio-16x9">
            <iframe
              id="videoFrame"
              allowFullScreen
              title="YouTube video player"
            ></iframe>
          </div>
        </div>
      </div>

      {/* About Section */}
      <AboutsSection />

      {/* Practice Area */}
      <PracticeArea />

      {/* Why Choose Us */}
      <WhyChooseUs />
      {/* Team Members */}
      <TeamMembers />

      {/* Testimonial Section */}
      <TestimonialSection />

      {/* Blog Wrapper */}
      <BlogWrapper />

      {/* Footer */}
      <Footer />

      {/* Scroll To Top */}
      <ScrollToTop />

      {/* Magnet Cursor */}
      <MagnetCursor />
    </div>
  );
}

export default HomeFour;
